import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./component/style.css";

import Navbar from "./component/Navbar";
import IndexPage from "./component/index/IndexPage";
import About from "./component/about/About";
import Contact from "./component/contact/Contact";


export default function App() {
  return (
    <Router>
      <div>
        <Navbar />
        <Routes>
          <Route path="/" element={<IndexPage />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </div>
    </Router>
  );
}
